import React, {useState, useEffect} from "react";
import {Container, Row} from "react-bootstrap";

import OpenedLetterIcon from "assets/icons/opened-letter-icon.png";
import ClosedLetterIcon from "assets/icons/closed-letter-icon.png";
import ShieldLockIcon from "assets/icons/shield-lock.png";
import SendResetPassword from "./SendResetPassword";
import ChangePassword from "./ChangePassword";
import TextView from "./TextView";
import {useDispatch} from "react-redux";
import {hideModal, showLogin} from "actions/ui_control";

function ResetPassword({
                         // setShow,
                         // setShowLogin,
                         paramsToken,
                         paramsUID,
                       }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const resetState = () => {
    setEmail("");

    setLoading(false);
  };
  const views = {
    requestPasswordResetView: 1,
    confirmPasswordResetView: 2,
    confirmedEmailView: 3,
    changePasswordView: 4,
    successPasswordResetView: 5,
  };
  const [view, setView] = useState(views.requestPasswordResetView);

  useEffect(() => {
    setView(views.requestPasswordResetView);
    setLoading(false);

    if (paramsToken && paramsUID) setView(views.changePasswordView);
  }, []);
  const dispatch = useDispatch();

  const hideModalFunc = () => {
    dispatch(hideModal());
    resetState();
  };
  const showLoginFunc = () => {
    dispatch(showLogin());
  };
  return (
    <Container>
      <Row>
        {view === views.requestPasswordResetView && (
          <SendResetPassword
            setView={setView}
            setEmail={setEmail}
            nextView={views.confirmPasswordResetView}
          />
        )}
        {view === views.changePasswordView && (
          <ChangePassword
            paramsUID={paramsUID}
            paramsToken={paramsToken}
            setView={setView}
            nextView={views.successPasswordResetView}
          />
        )}
        {view === views.confirmPasswordResetView && (
          <TextView
            image={ClosedLetterIcon}
            title={"Reset Password"}
            text={
              <>
                An email has been sent to{" "}
                <span style={{color: "#A5E1AD"}}>{email}</span>
              </>
            }
            handleClick={hideModalFunc}
            loading={loading}
            btnText={"Close"}
          >
            <p>
              Please check your inbox for the password reset link.
            </p>
          </TextView>
        )}
        {view === views.successPasswordResetView && (
          <TextView
            image={ShieldLockIcon}
            title={"Password successfully created!"}
            text={"You may now continue and log in using the new password."}
            handleClick={showLoginFunc}
            loading={loading}
            btnText={"Continue"}
          />
        )}
        {view === views.confirmedEmailView && (
          <TextView
            image={OpenedLetterIcon}
            title={"Mail successfully confirmed"}
            text={
              "You have successfully confirmed your email. You may now proceed to reset your password."
            }
            handleClick={() => {
              setView(views.changePasswordView);
            }}
            loading={loading}
            btnText={"Continue"}
          />
        )}
      </Row>
    </Container>
  );
}

export default ResetPassword;
